"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const one_1 = require("remax/one");
const icon_1 = __importDefault(require("../icon"));
const common_1 = require("../common");
const prefixCls = common_1.getPrefixCls('result');
const getIconNameByStatus = (status) => {
    let obj = {
        name: 'infofill',
        color: '#1890ff',
    };
    switch (status) {
        case 'info':
            obj = {
                name: 'infofill',
                color: '#1890ff',
            };
            break;
        case 'success':
            obj = {
                name: 'roundcheckfill',
                color: '#52c41a',
            };
            break;
        case 'warning':
            obj = {
                name: 'warnfill',
                color: '#faad14',
            };
            break;
        case 'error':
            obj = {
                name: 'roundclosefill',
                color: '#f5222d',
            };
            break;
        default:
            break;
    }
    return obj;
};
const Result = (props) => {
    const { status = 'info', title, subTitle, extra, children, icon, height } = props;
    let isCustomIcon = false;
    let iconObj = getIconNameByStatus(status);
    if (icon) {
        if (Object.prototype.toString.call(icon) === '[object Object]') {
            iconObj = icon;
        }
        else {
            isCustomIcon = true;
        }
    }
    return (React.createElement(one_1.View, { className: prefixCls, style: { height: height || '100vh' } },
        React.createElement(one_1.View, { className: `${prefixCls}-icon` }, isCustomIcon ? (icon) : (React.createElement(one_1.View, { className: `${prefixCls}-icon-status` },
            React.createElement(icon_1.default, { type: iconObj.name, color: iconObj.color, size: "168px" })))),
        React.createElement(one_1.View, { className: `${prefixCls}-title` }, title),
        React.createElement(one_1.View, { className: `${prefixCls}-sub_title` }, subTitle),
        children ? React.createElement(one_1.View, { className: `${prefixCls}-content` }, children) : null,
        React.createElement(one_1.View, { className: `${prefixCls}-extra` }, extra)));
};
exports.default = Result;
